<script lang="ts" setup>
import AUApi from "@/api";
import { ref, reactive, onMounted } from "vue";

import {
  AufgabeStatusZuordnung,
  AufgabeStatusAbfrage,
} from "../ChartTypesAndFunctions";
import {
  initChartBase,
  ChartBaseProperties,
  ChartBaseUiData,
  getKZAufgabeDefiniton,
  ChartBaseParameters,
} from "./ChartBaseStatic";
import { goBack } from "@/NavigationHelper";
import DashboardChartsZuordnungenMenu from "@/components/dashboard/Charts/ZuordnungenMenu.vue";
import baseChartList from "@/components/baseChartList.vue";
interface ListeProps extends ChartBaseProperties {
  persoenlich?: boolean;
}
interface ListeUiData extends ChartBaseUiData {
  showLoading: boolean;
  showZuordnung: boolean;
  pers: boolean;
  zuordnungen: AufgabeStatusZuordnung[];
}

const props = defineProps<ListeProps>();
const emit = defineEmits(["refresh", "info", "hideDialogTitel"]);

const { ui, params } = initChartBase<ListeUiData, ChartBaseParameters>(
  props,
  {
    showZuordnung: true,
  },
  {},
);
const uiData = reactive<ListeUiData>(ui);
let showFilter = ref<boolean>(false);
let showHeader = ref<boolean>(false);
let showAvatarLeft = ref<boolean>(false);
let showSpeedDial = ref<boolean>(false);
let showAvatar = ref<boolean>(false);
let drucke = ref<ALLDruck[]>([]);
let exporte: AufgabeStatusAbfrage[] = [];
let initalized = ref<boolean>(false);
let baseListVector = ref<number[]>();
let maxWidth = window.innerWidth - 10;

let componentKey = ref<number>(0);

onMounted(async () => {
  // aus dem DS - KPI kann aic als Object kommen = Aufgabe.. die darf ich aber nciht weiter geben - da aic eine NUMMER sein muss...daher hier sicherheitshalber prüfen!

  if (typeof params.aic === "object") {
    params.aic = undefined;
  }
  drucke.value = uiData.zuordnungen
    ?.filter((z) => z.gruppe === "Druck") // Modelle dürfen nicht übergeben werden - sind soinst unter DRUCK drinnen!
    .map((z) => z as ALLDruck);
  if (drucke.value.length === 0) {
    uiData.showZuordnung = false;
  }

  exporte = uiData.zuordnungen
    ?.filter((z) => z.gruppe === "Abfrage")
    .map((z) => z as AufgabeStatusAbfrage);
  showAvatar.value = getKZAufgabeDefiniton(uiData, props, params, "showAvatar");
  showAvatarLeft.value = getKZAufgabeDefiniton(
    uiData,
    props,
    params,
    "showAvatarLeft",
  );
  showSpeedDial.value = getKZAufgabeDefiniton(
    uiData,
    props,
    params,
    "showSpeedDial",
  );
  showHeader.value = getKZAufgabeDefiniton<boolean>(
    uiData,
    props,
    params,
    "showHeader",
  );
  showFilter.value = getKZAufgabeDefiniton<boolean>(
    uiData,
    props,
    params,
    "showFilter",
  );
  const hideZuordnung = getKZAufgabeDefiniton<boolean>(
    uiData,
    props,
    params,
    "hideZuordnung",
  );
  uiData.showZuordnung = !hideZuordnung;
  if (showHeader) {
    emit("hideDialogTitel");
  }
  initalized.value = true;
});
// function concatVector() {
//   return baseListVector.concat(baseListVector);
// }

function setzeVectorBaseListe(args: number[]) {
  uiData.showZuordnung = false;
  baseListVector.value = args;
  componentKey.value += 1;
  uiData.showZuordnung = true;
}
</script>
<template>
  <v-card density="compact" flat tile>
    <baseChartList
      v-if="initalized && uiData.aufgabenDefinition"
      :showClose="false"
      :query="params.query"
      :showFilter="showFilter"
      :showSpeedDial="showSpeedDial"
      :showAvatarLeft="showAvatarLeft"
      :showAvatar="showAvatar"
      class="scrollList pa-0"
      :showHeader="showHeader"
      @vector="setzeVectorBaseListe"
      :druckItems="drucke"
      :exportItems="exporte"
      :print="true"
      @back="goBack()"
      :persoenlich="props.persoenlich"
      :formular="params.aufgabe"
    />
    <span v-else>missing data Liste:(</span>
    <v-card-actions v-if="uiData.showZuordnung" class="pa-0">
      <v-spacer></v-spacer>
      <DashboardChartsZuordnungenMenu
        :key="componentKey"
        :zuordnungen="uiData.zuordnungen"
        v-if="uiData.zuordnungen && uiData.zuordnungen.length > 0"
        :aic="params.aic"
        :vector="baseListVector"
        :showButtons="true"
        :onlyVector="true"
        :persoenlich="props.persoenlich"
        :zeitbereich="AUApi.Current.zeitbereich"
      />
    </v-card-actions>
  </v-card>
</template>
